// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
function loginRedirect({ route, redirect }) {
  const url =
    process.env.NODE_ENV === "production" && process.env.LIVE === "1"
      ? "https://dashboard.commonshare.com/login"
      : "https://dashboard.minion.commonstaging.me/login";
  if (route.fullPath === "/login") {
    return redirect(url);
  }
  return null;
}

export default loginRedirect;
